// node modules
import StackTrace, { StackFrame } from 'stacktrace-js';

// modules
import AnalyticsService from 'modules/Analytics';
import { LOCAL } from 'config';
import { EVENTS } from 'modules/Analytics/consts';

// typings
import { CrashData } from './typings';

export const isError = (value: Error) => {
  if (Object.prototype.toString.call(value) === '[object Error]') {
    return true;
  }
  return value instanceof Error;
};

export const createErrorObj = (error: Error, stackFrames: StackFrame[]) => {
  const errorObj: CrashData = {
    message: `${error.message || ''}`,
    frames: [],
  };

  if (stackFrames?.length) {
    stackFrames.forEach((stackFrame: StackFrame) => {
      const {
        columnNumber,
        lineNumber,
        fileName,
        functionName,
        source,
      } = stackFrame;

      let fileNameParsed = '<unknown>';
      if (fileName) {
        const subStrLen = fileName.indexOf('?');
        if (subStrLen < 0) {
          fileNameParsed = fileName;
        } else if (subStrLen > 0) {
          fileNameParsed = fileName.substring(0, subStrLen);
        }
      }
      errorObj.frames.push({
        src: source || '<unknown>',
        line: lineNumber || 0,
        col: columnNumber || 0,
        fn: functionName || '<unknown>',
        file: `${fileNameParsed}:${lineNumber || 0}:${columnNumber || 0}`,
      });
    });
  }

  return errorObj;
};

const errorHandler = (
  error: Error,
  { componentStack }: { componentStack: string },
) => {
   if (!LOCAL) {
    if (isError(error)) {
      StackTrace.fromError(error, { offline: true }).then(stackFrames => {
        const errorObj = createErrorObj(error, stackFrames);
        // Log to mixpanel
        const { message = 'Unknown Error Occured', frames = [] } = errorObj;
        const stackTrace = JSON.stringify(frames);

        AnalyticsService.sendEvent(EVENTS.ERROR_OCCURRED, {
          Error: message,
          'Component Stack Trace': stackTrace,
          'Component Stack': componentStack,
        });
      });
    } else {
      AnalyticsService.sendEvent(EVENTS.ERROR_OCCURRED, {
        Error: 'Unknown Error Occured',
        'Component Stack': componentStack,
      });
    }
  }
};

export default errorHandler;
